import React, { useState } from "react";
import styles from "./HomePageNewsCard.module.css";
import {
  hasViewedLocalCombinationNews,
  setViewedLocalCombinationNews,
} from "../../helpers/newsHelpers";
import SmallXIcon from "@coworker/components/src/assets/svg/icon-close-small-crop.svg?react";

interface HomePageNewsCardProps {
  title: string;
}

export const HomePageNewsCard: React.FC<HomePageNewsCardProps> = ({
  title,
}) => {
  const [viewed, setViewed] = useState(hasViewedLocalCombinationNews());

  const handleClick = () => {
    setViewed(!viewed);
    setViewedLocalCombinationNews(!viewed);
  };

  if (viewed) return null;

  return (
    <div className={styles["card"]}>
      <button
        type="button"
        className={styles["closeButton"]}
        onClick={handleClick}
        data-testid="searchClear"
      >
        <SmallXIcon width={40} height={40} />
      </button>
      <div className={styles["textContainer"]}>
        <h2 className={styles["title"]}>{title}</h2>
      </div>
    </div>
  );
};
